import Vue from 'vue'
import EventBus from '../_event-bus'
import { $, $$ } from '../_utils'
import RequestHelper from '../_request-helper'

const BREAKPOINT = 768
const ORDER_SEND_DATA_ENDPOINT = process.env.ORDER_SEND_DATA_ENDPOINT

Vue.component('vue-form', {
  template: '#vue-form-template',
  props: {
    formData: Object,
    type: String,
    taxOffices: Array,
    errorsList: Array,
    localitiesArray: Array,
    shippingLocalitiesArray: Array,
  },
  data() {
    return {
      allRefs: [],
      isAflofarmPlus: false,
      isMobile: false,
      formItems: {},
      formItemsParsed: {},
      offices: [],
      localities: [],
      shippingLocalities: [],
      isBusinessChanged: false,
      initialBusiness: '',
      form: {},
      errors: [],
      isValid: null,
      requiredFields: [],
      breakpoint: null,
    }
  },
  methods: {
    // GET FORM ELEMENTS

    getUserForm() {
      this.form = $('#userForm')
    },

    // SET BREAKPOINTS AND LAYOUT

    setBreakpoint() {
      if (this.$props.type === 'cart') this.breakpoint = 768
      else if (this.$props.type === 'my-account') this.breakpoint = 992
    },
    setLayout(viewporWidth) {
      this.isMobile = viewporWidth < this.breakpoint
    },

    // SET EVENTS LISTENERS:

    subscribeToResizeListener() {
      EventBus.$on('resize', this.setLayout)
    },
    addDatePickerUpdateListener() {
      EventBus.$on('date-picker-data-updated', this.setDataFromDatePickers)
    },
    addTaxOfficeUpdateListener() {
      EventBus.$on('tax-office-selected', this.setTaxOffice)
    },
    addLocalityUpdateListener() {
      EventBus.$on('locality-selected', this.setLocality)
    },
    addShippingLocalityUpdateListener() {
      EventBus.$on('shipping-locality-selected', this.setShippingLocality)
    },
    addSubmiListener() {
      EventBus.$on('form-submit-btn-clicked', this.handleFormSubmit)
    },
    addChoicesRequestListener() {
      EventBus.$on('localities-changed', data => {
        this.localities = data.choices
      })
      EventBus.$on('shippingLocalities-changed', data => {
        this.shippingLocalities = data.choices
      })
    },

    // SET FORM DATA:

    setFormItems() {
      this.formItems = this.$props.formData
    },
    setInitialBusiness() {
      this.initialBusiness = this.$props.formData.business
    },
    setInitialSelectValue(items, itemToSelect) {
      items.forEach(item => {
        if (item.selected === true) item.selected === false
        if (item.label === itemToSelect) item.selected = true
      })
    },
    setLocalities() {
      this.localities = this.$props.localitiesArray
    },
    setShippingLocalities() {
      this.shippingLocalities = this.$props.shippingLocalitiesArray
    },
    setTaxOffices() {
      this.offices = this.$props.taxOffices
    },
    setIsAflofarmPlus() {
      if (document.body.className.includes('is-aflofarm-plus')) this.isAflofarmPlus = true
      else this.isAflofarmPlus = false
    },

    // SAVE DATA FROM SELECTS

    setDataFromDatePickers(data) {
      switch (data.name) {
        case 'dateOfBirth':
          this.formItems.dateOfBirth = data.activeDate
          break
        case 'dateOfBusinessResignation':
          this.formItems.dateOfBusinessResignation = data.activeDate
          break
      }
      // this.handleInput(data)
    },
    setTaxOffice(data) {
      this.handleInput(data)
      this.formItems.taxOffice = data.choice
    },
    setLocality(data) {
      this.handleInput(data)
      this.formItems.locality = data.choice
    },
    setShippingLocality(data) {
      this.handleInput(data)
      this.formItems.shippingLocality = data.choice
    },

    // SAVE DATA FROM CHECKBOXES

    handleNipCheckbox() {
      if (!this.formItems.isNip) {
        this.formItems.nipNumber = ''
      } else {
        this.formItems.personalNumber = ''
      }
    },

    // HANDLE FORM EVENTS

    handleBusinessChange(event) {
      this.isBusinessChanged = this.initialBusiness !== this.formItems.business
      if (this.formItems.business === 'no') this.formItems.taxOffice = ''
    },
    handleFormSubmit() {
      this.isValid = false
      this.handleValidation()
    },
    handleShippingAdressFill() {
      const initialIsShippingSame = this.formItems.isShippingSame
      if (this.formItems.isShippingSame) {
        this.formItems.shippingUserName = this.formItems.userName
        this.formItems.shippingUserSurname = this.formItems.userSurname
        // this.formItems.shippingEmail = this.formItems.email
        this.formItems.shippingStreet = this.formItems.street
        this.formItems.shippingHomeNumber = this.formItems.homeNumber
        this.formItems.shippingApartmentNumber = this.formItems.apartmentNumber
        this.formItems.shippingPostcode = this.formItems.postcode
        this.formItems.shippingLocality = this.formItems.locality
        // this.formItems.shippingPhone = this.formItems.phone
        this.shippingLocalities = this.localities
        this.formItems.shippingPostOffice = this.formItems.postOffice

        EventBus.$emit('isShippingSame-changed', {
          choices: this.shippingLocalities,
          choice: this.formItems.locality,
        })

        $$('.input-wrapper', this.$refs.shippingAdress).forEach(item => {
          if (item.className.includes('invalid')) item.classList.remove('invalid')
        })
      }
    },

    handleInput(event) {
      this.removeInvalidClass(event)
      if (event.target && event.target.parentNode.className.includes('valid'))
        event.target.parentNode.classList.remove('valid')
    },

    // SET VALIDATION CLASSES

    removeInvalidClass(event) {
      if (!event.name) {
        if (event.target.parentNode.className.includes('invalid'))
          event.target.parentNode.classList.remove('invalid')
        this.removeFromErrors(event.srcElement.id)
      } else {
        if (this.$refs[event.name].parentNode.className.includes('invalid'))
          this.$refs[event.name].parentNode.classList.remove('invalid')
        this.removeFromErrors(event.name)
      }
    },
    setValidClass(name) {
      if (this.$refs[name]) {
        if (this.$refs[name].parentNode.className.includes('invalid'))
          this.$refs[name].parentNode.classList.remove('invalid')
        this.$refs[name].parentNode.classList.add('valid')
      }
    },

    // VALIDATION

    handleValidation(shouldSubmit = true) {
      this.checkRequiredFields()

      if (this.formItems.nipNumber && !this.findInErrors('nipNumber') && this.formItems.isNip)
        this.testNipNumber()

      if (
        this.formItems.personalNumber &&
        !this.findInErrors('personalNumber') &&
        !this.formItems.isNip
      )
        this.testPersonalNumber()

      // check postcode format

      if (
        this.formItems.postcode &&
        !this.findInErrors('postcode') &&
        !this.testPostcode(this.formItems.postcode)
      )
        this.addToErrors('postcode', 'Błędny kod pocztowy')

      if (
        this.formItems.shippingPostcode &&
        !this.findInErrors('shippingPostCode') &&
        !this.testPostcode(this.formItems.shippingPostcode)
      )
        this.addToErrors('shippingPostcode', 'Błędny kod pocztowy')

      if (
        this.formItems.email &&
        !this.findInErrors('email') &&
        !this.isEmailCorrect(this.formItems.email)
      )
        this.addToErrors('email', 'Błędny adres e-mail')

      if (
        this.formItems.shippingEmail &&
        !this.findInErrors('shippingEmail') &&
        !this.isEmailCorrect(this.formItems.shippingEmail)
      )
        this.addToErrors('shippingEmail', 'Błędny adres e-mail')

      if (
        this.formItems.taxOffice &&
        this.formItems.taxOffice === 'first-item-value' &&
        !this.findInErrors('taxOffice') &&
        this.formItems.business === 'no'
      )
        this.addToErrors('taxOffice', 'Wybierz urząd skarobowy')

      if (
        this.formItems.userKamsoftNumber &&
        !this.findInErrors('userKamsoftNumber') &&
        isNaN(Number(this.formItems.userKamsoftNumber))
      )
        this.addToErrors('userKamsoftNumber', 'To pole musi zawierać liczbę')

      if (
        this.formItems.pharmacyKamsoftNumber &&
        !this.findInErrors('pharmacyKamsoftNumber') &&
        isNaN(Number(this.formItems.pharmacyKamsoftNumber))
      )
        this.addToErrors('pharmacyKamsoftNumber', 'To pole musi zawierać liczbę')

      // check if name and surname contain any sings different than alphabet letters

      this.setErrors()
      this.markCorrect()
      if (this.errors.length === 0) {
        this.isValid = true
      }

      if (this.isValid && shouldSubmit) this.form.submit()
    },

    // TESTS

    checkRequiredFields() {
      // filter not rendered fields

      this.allRefs = Object.keys(this.$refs)
      this.requiredFields = []
      this.allRefs.forEach(entry => {
        if (this.$refs[entry]) {
          this.requiredFields.push(entry)
        }
      })
      this.requiredFields.forEach(field => {
        if (this.$refs[field].dataset.required) {
          this.requiredFields = this.requiredFields.filter(name => {
            return field !== name
          })
        }
      })
      this.errors = this.requiredFields
        .map(key => {
          return !this.formItems[key] ? { name: key, text: 'To pole jest wymagane' } : null
        })
        .filter(item => {
          return item !== null
        })
        .filter(item => {
          return item.name !== 'shippingAdress'
        })
    },

    // TESTS

    isNumberCheck(number) {
      var pattern = /^\d+$/
      return pattern.test(number)
    },
    isEmailCorrect(text) {
      const pattern = /\S+@\S+\.\S+/
      return pattern.test(text)
    },
    testNipNumber() {
      const stringNipNumber = this.formItems.nipNumber.toString().replace(/[\-]/gi, '')

      // checks type and length
      if (!this.isNumberCheck(stringNipNumber) || stringNipNumber.length !== 10) {
        this.addToErrors('nipNumber', 'Numer NIP powinien zawierać 10 cyfr')
        return
      }

      // checks the control sum
      let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7]
      let sum = 0
      let controlNumber = parseInt(stringNipNumber.substring(9, 10))
      let weightCount = weight.length
      for (let i = 0; i < weightCount; i++) {
        sum += parseInt(stringNipNumber.substring(i, i + 1)) * weight[i]
      }

      if (sum % 11 !== controlNumber) {
        this.addToErrors('nipNumber', 'Nieprawidłowy numer NIP')
      }
    },
    testPersonalNumber() {
      const stringPersonalNumber = this.formItems.personalNumber.toString()

      // checks type and length
      if (
        !this.isNumberCheck(this.formItems.personalNumber) ||
        stringPersonalNumber.length !== 11
      ) {
        this.addToErrors('personalNumber', 'Numer PESEL powinien zawierać 11 cyfr')
        return
      }

      // checks the control sum
      const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3]
      let sum = 0
      let controlNumber = parseInt(stringPersonalNumber.substring(10, 11))

      for (let i = 0; i < weight.length; i++) {
        sum += parseInt(stringPersonalNumber.substring(i, i + 1)) * weight[i]
      }
      sum = sum % 10
      if ((10 - sum) % 10 !== controlNumber) {
        this.addToErrors('personalNumber', 'Nieprawidłowy numer PESEL')
        return
      }

      // compares with date of birth
      const dateOfBirth = new Date(this.formItems.dateOfBirth)
      const year = dateOfBirth.getFullYear().toString().substring(2)
      const month =
        dateOfBirth.getFullYear() > 1999 ? dateOfBirth.getMonth() + 21 : dateOfBirth.getMonth() + 1 // getMonths method returns integer number between 0 and 11
      const day = dateOfBirth.getDate()

      if (
        stringPersonalNumber.substring(0, 2) != year || // checks year
        stringPersonalNumber.substring(2, 4) != month || // checks month
        stringPersonalNumber.substring(4, 6) != day // checks day
      ) {
        this.addToErrors('personalNumber', 'Numer pesel nie zgadza się z datą urodzenia')
      }
    },
    testPostcode(code) {
      const pattern = /[0-9]{2}\-[0-9]{3}/
      return pattern.test(code)
    },

    // VALIDATION HELPERS

    addToErrors(name, text) {
      this.errors = [{ name: name, text: text }, ...this.errors]
    },
    findInErrors(name) {
      return this.errors.find(error => error.name === name)
    },
    markCorrect() {
      Object.keys(this.formItems)
        .filter(name => {
          return name !== 'isNip'
        })
        .filter(name => {
          return name !== 'isShippingSame'
        })
        .forEach(name => {
          if (!this.errors?.find(error => error.name === name)) {
            this.setValidClass(name)
          }
        })
    },
    removeFromErrors(errorName) {
      if (this.errors)
        this.errors = this.errors.filter(error => {
          return error.name !== errorName
        })
    },
    setErrors() {
      if (!this.errors) return
      this.errors.forEach(error => {
        if (this.$refs) this.setSingleError(error)
      })
      if (document.querySelectorAll('.invalid')[0]) {
        document
          .querySelectorAll('.invalid')[0]
          .scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    setSingleError(error) {
      if (error.name && this.$refs[error.name]) {
        this.$refs[error.name].innerHTML = error.text
        this.$refs[error.name].parentNode.classList.add('invalid')
      }
    },
  },
  created() {
    this.setFormItems()
    this.setInitialBusiness()
    this.setLocalities()
    this.setTaxOffices()
    this.setShippingLocalities()
    this.errors = this.$props.errorsList
  },
  mounted() {
    this.setBreakpoint()
    this.getUserForm()
    this.setIsAflofarmPlus()
    this.handleShippingAdressFill()
    this.subscribeToResizeListener()
    this.addDatePickerUpdateListener()
    this.addTaxOfficeUpdateListener()
    this.addLocalityUpdateListener()
    this.addShippingLocalityUpdateListener()
    this.addChoicesRequestListener()
    this.addSubmiListener()
    this.setLayout(window.innerWidth)
    this.$nextTick(() => {
      this.setErrors()
      this.markCorrect()
      this.handleValidation(false)
    })
  },
})

const el = $('#vue-form-wrapper')
if (el) window.addEventListener('load', () => new Vue({ el }))
